import { Fragment, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { orderBy } from "@progress/kendo-data-query";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const AlertNotificationGrouped = props => {
    const {currentTheme, headers, values, operatorTitle, isPercent, ...other} = props;
    
    const isOperatorRange = operatorTitle.toLowerCase().indexOf("in") >= 0;

    const maxVisibleRows = 5;//212px
    const rows = values.length;
    let height = 212;    
    if (rows < 5)
        height = (37 * rows) + 48;

    const initialGridSort = [        
    ];

    const [gridSort, setGridSort] = useState(initialGridSort);

    const { t } = useTranslation();

    return (
        <Fragment>
            <div className="alert-notification-grouped">
                <Grid style={{height: "100%", width: "100%"}} /*height was height var*/
                    data={orderBy(values, gridSort)} 
                    resizable={true}
                    reorderable={true}
                    sortable={{
                        allowUnsort: true,
                        mode: "multiple",
                    }} 
                    sort={gridSort}
                    onSortChange={(e) => {
                      setGridSort(e.sort);
                    }}
                    >
                    {
                        headers.map(item => 
                        {                           
                            const count = headers.length;
                            const fields = count - 5;
                            let variatonWidth = fields == 1 ? "calc(100% - 525px)" : 110;

                            if (item == "AlertLogId")
                                return undefined;
                            else if (item == "KeyMetric")
                                return <GridColumn key={item} field={item} title={t("notifications.keymetric")} width={210} className="key-metric"/>
                            else if (item == "AchievedValue")
                                return <GridColumn key={item} field={item} title={isPercent ? t("notifications.valuep") : t("notifications.value")} width={100}  className="achieved-value" />
                            else if (item == "OperatorTitle")
                                return <GridColumn key={item} field={item} title={t("notifications.operator")} width={125}  className="operator-title" />
                            else if (item == "ThresholdMin")
                            {
                                if (isOperatorRange)
                                    return <GridColumn key={item} field={item} title={isPercent ? t("notifications.minp") : t("notifications.min")} width={110}  className="threshold"/>
                                else
                                    return <GridColumn key={item} field={item} title={isPercent ? t("notifications.threshp") : t("notifications.thresh")} width={110}  className="threshold"/>
                            }
                            else if (item == "ThresholdMax")
                            {
                                if (isOperatorRange)
                                    return <GridColumn key={item} field={item} title={isPercent ? t("notifications.maxp") : t("notifications.max")} width={110}  className="threshold"/>
                                else
                                    return undefined
                            }
                            else if (item == "Variation")
                                return <GridColumn key={item} field={item} title={t("notifications.varp")} width={variatonWidth}  className="variation"/>                            
                            else //grouped field
                                return <GridColumn key={item} field={item} title={item} width={150} />
                        }
                        )
                    }
                </Grid>
            </div>
            <style>
                {
                    `
                    .notifications-page .alert-notification-grouped 
                    {
                        display: flex;
                        flex:1;
                        align-items: stretch;
                        justify-content: space-between;
                        margin-top:6px;
                        overflow-y: auto;
                    }

                    .notifications-page .alert-notification-grouped .k-grid 
                    {
                        border: ${currentTheme.gridBorder};
                    }

                    .notifications-page .alert-notification-grouped .k-grid .k-grid-content
                    {
                        overflow-y: auto;
                    }

                    .notifications-page .alert-notification-grouped .k-grid table thead tr
                    {
                        background-color: ${currentTheme.gridHeaderBg};
                        color: ${currentTheme.gridHeaderColor};
                    }

                    .notifications-page .alert-notification-grouped .k-grid .key-metric
                    {
                    }

                    .notifications-page .alert-notification-grouped .k-grid .achieved-value
                    {
                        text-align: center;
                    }

                    .notifications-page .alert-notification-grouped .k-grid .operator-title
                    {
                        text-align: center;
                    }

                    .notifications-page .alert-notification-grouped .k-grid .threshold
                    {
                        text-align: center;
                    }

                    .notifications-page .alert-notification-grouped .k-grid .variation
                    {
                        text-align: center;
                    }

                    .notifications-page .alert-notification-grouped .k-grid .k-grid-header thead tr th:nth-last-child(1) .k-link,
                    .notifications-page .alert-notification-grouped .k-grid .k-grid-header thead tr th:nth-last-child(2) .k-link,
                    .notifications-page .alert-notification-grouped .k-grid .k-grid-header thead tr th:nth-last-child(3) .k-link,
                    .notifications-page .alert-notification-grouped .k-grid .k-grid-header thead tr th:nth-last-child(4) .k-link
                    {
                        justify-content: center;
                    }

                    .notifications-page .alert-notification-grouped .k-grid .k-master-row > td
                    {
                        border-bottom: 1px solid ${currentTheme.componentBorderColor};
                    }

                    .notifications-page .alert-notification-grouped .k-grid .k-master-row:last-child > td
                    {
                        border-bottom: none;
                    }

                    .notifications-page .alert-notification-grouped .k-grid .k-master-row.k-alt,
                    .notifications-page .alert-notification-grouped .k-grid .k-master-row.k-alt:hover,
                    .notifications-page .alert-notification-grouped .k-grid .k-master-row:hover
                    {
                        background-color: ${currentTheme.componentBg};
                    }                    
                    
                    .notifications-page .alert-notification-grouped .k-grid tr td:not(first-child)
                    {
                        border-left: none;
                    }

                    `
                }
            </style>
        </Fragment>
    );
};